export const stepStatus = {
    Inprogress: 'INPROGRESS',
    New: 'NEW',
    Complete: 'COMPLETE',
    Abandon: 'ABANDON',
    Cancel: 'CANCEL',
    Submitted: 'SUBMIT'
}